export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDcgMTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjA5MDI0IDUuMTQ0NTdMMC41NTUxNzYgMS42MDg5M0wxLjk2OTUxIDAuMTk0ODMyTDYuOTE4NDUgNS4xNDQ1OUwxLjk2OTUgMTAuMDk0MkwwLjU1NTE4NCA4LjY4MDEyTDQuMDkwMjQgNS4xNDQ1N1oiIGZpbGw9IiM0RjU4RjUiLz4KICA8L3N2Zz4KICA="


//////////////////
// WEBPACK FOOTER
// ./images/chevron-right.svg
// module id = 261
// module chunks = 0